export default __webpack_public_path__ + "src/assets/newTab.c8bf5b06c83465a1b5e0b45aa24da3a0.svg";